import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stylesTemplate"]

  declare readonly stylesTemplateTarget: HTMLTemplateElement

  // Called once stylesTemplate is connected in blog and my-account
  stylesTemplateTargetConnected(): void {
    const styleTag = this.stylesTemplateTarget.content.cloneNode(true) as HTMLElement

    document.head.prepend(styleTag)
  }
}
